'use client';

import {
  Root,
  Anchor,
  Portal,
  Content,
  Trigger,
} from '@radix-ui/react-popover';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Popover(props: ComponentProps<typeof Root>): JSX.Element {
  return <Root data-slot='popover' {...props} />;
}

export function PopoverTrigger(
  props: ComponentProps<typeof Trigger>,
): JSX.Element {
  return <Trigger data-slot='popover-trigger' {...props} />;
}

export function PopoverContent({
  className,
  sideOffset = 4,
  align = 'center',
  ...props
}: ComponentProps<typeof Content>): JSX.Element {
  return (
    <Portal>
      <Content
        align={align}
        sideOffset={sideOffset}
        data-slot='popover-content'
        className={cn(
          'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden',
          className,
        )}
        {...props}
      />
    </Portal>
  );
}

export function PopoverAnchor(
  props: ComponentProps<typeof Anchor>,
): JSX.Element {
  return <Anchor data-slot='popover-anchor' {...props} />;
}
